import { styled } from "@mui/material/styles";
import { HubCardStack } from "../HubCardStack";
import { Stack } from "@mui/material";
import { HubHookFormDatePicker } from "../HubHookFormDatePicker";

const highlightColor = "white";
const inputColor = "blueMainTransparent";

export const BasicCardStack = styled(HubCardStack)(({ theme }) => ({
  padding: "5px",
  borderRadius: 0,
  borderColor: theme.palette.hubColors.grey,
}));

export const StyledCardStack = styled(BasicCardStack)(({ theme }) => ({
  width: "40%",
  flexGrow: 0,
}));

export const StyledCardRow = styled(BasicCardStack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  alignItems: "center",
  columnGap: "25px",
  padding: "0px 5px",
  // height: "35px",
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "start",
    alignItems: "center",
    width: "100%",
    height: "100%",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset, textarea": {
      height: "100%",
      border: "0px",
    },
    textarea: {
      height: "100% !important",
    },
    "input, fieldset, textarea": {
      backgroundColor: "transparent",
    },
    "fieldset, textarea": {
      fontWeight: "400 !important",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      padding: "5px 2px 5px 4px",
      border: "0px",
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      minHeight: "inherit",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: 700,
        color: theme.palette.hubColors.greyDark,
        lineHeight: "12px",
        fontSize: "12px",
      },
    },
    ".LineItemDescription, .MuiAutocomplete-root": {
      ".MuiInputBase-root": {
        input: {
          fontWeight: "400 !important",
        },
      },
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      height: "100%",
      padding: "0px",
      ".MuiInputBase-root": {
        paddingRight: "4px !important",
      },
    },
  },
}));

export const StyledItemRow = styled(Stack, {
  shouldForwardProp: (prop) => !["header", "topBorder"].includes(prop),
})(({ theme, header, topBorder }) => ({
  display: "grid",
  gridTemplateColumns: "100px auto 200px 150px",
  padding: "3px 10px",
  alignItems: "center",
  borderColor: theme.palette.hubColors.grey,
  ...(topBorder
    ? {
        borderTop: "1px solid",
      }
    : {
        borderBottom: "1px solid",
      }),
  ...(header
    ? {
        backgroundColor: theme.palette.hubColors.greyLight,
      }
    : {}),
  ".MuiTypography-root": {
    lineHeight: "12px",
    height: "12px",
  },
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "start",
    alignItems: "center",
    width: "100%",
    height: "100%",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset, textarea": {
      height: "100%",
      border: "0px",
    },
    textarea: {
      height: "100% !important",
    },
    "input, fieldset, textarea": {
      backgroundColor: "transparent",
    },
    "fieldset, textarea": {
      fontWeight: "400 !important",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      padding: "5px 2px 5px 4px",
      border: "0px",
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      minHeight: "inherit",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: 700,
        color: theme.palette.hubColors.greyDark,
        lineHeight: "12px",
        fontSize: "12px",
      },
    },
    ".LineItemDescription, .MuiAutocomplete-root": {
      ".MuiInputBase-root": {
        input: {
          fontWeight: "400 !important",
        },
      },
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      height: "100%",
      padding: "0px",
      ".MuiInputBase-root": {
        paddingRight: "4px !important",
      },
    },
  },
}));

export const StyledLabelStack = styled(Stack, {
  shouldForwardProp: (prop) => !["c1"].includes(prop),
})(({ c1 = "100px" }) => ({
  display: "grid",
  gridTemplateColumns: `${c1} 1fr`,
  alignContent: "end",
  gap: "5px",
}));

export const StyledHubHookFormDatePicker = styled(HubHookFormDatePicker)(
  ({ theme }) => ({
    ".MuiInputBase-root": {
      display: "grid",
      gridTemplateColumns: "auto 20px",
      "input::placeholder": {
        color: theme.palette.hubColors.greyDark,
      },
      ".MuiInputAdornment-root": {
        height: "fit-content",
        maxHeight: "fit-content",
        margin: 0,
        ".MuiButtonBase-root": {
          padding: "0px",
        },
      },
    },
    ".MuiSvgIcon-root": {
      display: "inline-block !important",
      width: "14px",
      height: "14px",
    },
  }),
);

export const StyledShipmentBox = styled(Stack)(({ theme }) => ({
  minWidth: "250px",
  padding: "0px !important",
  gap: "2px",
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "end",
    alignItems: "center",
    width: "100%",
    height: "fit-content",
    ".MuiStack-root": {
      padding: 0,
      backgroundColor: "transparent",
    },
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset": {
      border: "0px",
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      minWidth: "100px",
      padding: "0px",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      minWidth: "100px",
      padding: "5px !important",
      borderRadius: "0px",
      backgroundColor: theme.palette.hubColors[inputColor],
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: "700",
        color: theme.palette.hubColors.greyDark,
        lineHeight: "12px",
        fontSize: "12px",
      },
    },
  },
}));
